import type { TABLE_CELL_TYPE } from 'types/enums.ts';
import { CatalogueImage } from 'components/user/catalogueWidget/CatalogueImage.tsx';
import { Text } from 'components/common/Table/cellComponents/Text.tsx';
import { Button } from 'components/mui/common/Button';
import { styled } from '@mui/material';
import { CatalogueWidgetEditableText } from 'components/user/catalogueWidget/CatalogueWidgetEditableText.tsx';
import type { FieldValues, UseFormReturn } from 'react-hook-form';
import type { ViewItem } from '../../types/catalogViewItem.ts';
import type { FileUrlResponse, InlineRecordType } from '../../types';

const ButtonWrapper = styled('div')(({ columns }: { columns?: number }) => ({
  display: 'grid',
  width: '100%',
  gap: '10px',
  gridTemplateColumns: `repeat(${columns}, 1fr)`,
}));

export const renderComponentByType = (
  viewItem: ViewItem | ViewItem[] | undefined,
  // eslint-disable-next-line
  form: UseFormReturn<FieldValues, any, FieldValues>,
  navigateAction?: (viewItem: ViewItem, attributes?: InlineRecordType[]) => void,
  handleSetCatalogData?: (fieldName: string, value: string | number) => void
) => {
  if (Array.isArray(viewItem) && viewItem?.some((item) => item?.kind === 'Button')) {
    return (
      <ButtonWrapper columns={viewItem?.length <= 3 ? viewItem.length : 3}>
        {viewItem?.map((button) => (
          <Button
            key={button?.id}
            sx={{ height: '42px', minWidth: 'fit-content' }}
            onClick={() => navigateAction?.(button)}
            variant="outlined"
            formItemUiDefinition={button?.visibilityResult?.formItemUiDefinition ?? undefined}
            type="button">
            {item.title}
          </Button>
        ))}
      </ButtonWrapper>
    );
  }

  const item = viewItem as ViewItem;

  const uiDef = item?.visibilityResult?.formItemUiDefinition ?? undefined;

  switch (item?.kind?.toLowerCase()) {
    case 'text':
    case 'number':
    case 'phonenumber':
    case 'email':
    case 'computed':
    case 'guid':
      return item?.isEditable ? (
        <CatalogueWidgetEditableText
          key={item?.id}
          control={form.control}
          inputName={item?.name ?? ''}
          setValue={form.setValue}
          viewItem={item}
          handleSetCatalogData={handleSetCatalogData}
        />
      ) : (
        <Text
          key={item?.id}
          type={item?.kind as TABLE_CELL_TYPE}
          value={item?.value}
          originalType={item?.itemSchema?.originalType}
          formItemUiDefinition={uiDef}
          wrap
        />
      );
    case 'fileupload':
      return <CatalogueImage key={item?.id} file={item?.file as FileUrlResponse} />;
    case 'button':
      return (
        <Button
          key={item?.id}
          sx={{ height: '42px', minWidth: 'fit-content' }}
          onClick={() => navigateAction?.(item)}
          variant="outlined"
          formItemUiDefinition={uiDef}
          type="button">
          {item.title}
        </Button>
      );
    default:
      return null;
  }
};
